/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Flex, Radio, RadioGroup, Spacer } from '@chakra-ui/react'
import { IValueString, IValueNumber, IValueBoolean } from '~core/Types/BaseModel'
import * as React from 'react'
import './index.scss'

interface RadioButtonProps {
  value?: string
  onChange: ((param: any) => void) | undefined
  options: IValueString[] & IValueNumber[] & IValueBoolean[]
}

const RadioButton: React.FC<RadioButtonProps> = ({ value, onChange, options }) => {
  return (
    <RadioGroup value={value} onChange={onChange} className="radio-group">
      <Flex>
        {(options || []).map((genre, key) => (
          <>
            <Box p="4" key={key}>
              <Radio value={genre.value}>{genre.label}</Radio>
            </Box>
            {key === 0 && <Spacer />}
          </>
        ))}
      </Flex>
    </RadioGroup>
  )
}

export default RadioButton
